module.exports = __webpack_public_path__ + "img/alert-yellow.9278a3dc.svg";